import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IUser } from "../types";

export interface Users {
  users: IUser | null;
  accessToken: string;
  refreshToken: string;
}

export const initialState: Users = {
  users: null,
  accessToken: "",
  refreshToken: "",
};

export const users = createSlice({
  name: "users",
  initialState,
  reducers: {
    createUser: (state, action: PayloadAction<{ users: IUser }>) => {
      state.users = action.payload.users;
      localStorage?.setItem("Email", action.payload.users.Email);
      localStorage.setItem("Wallet", action.payload.users.Wallet);
    },
    setUserToken: (
      state,
      action: PayloadAction<{ accessToken: string; refreshToken: string }>
    ) => {
      state.accessToken = action.payload.accessToken;
      state.refreshToken = action.payload.refreshToken;
      localStorage.setItem("accessToken", action.payload.accessToken);
      localStorage.setItem("refreshToken", action.payload.refreshToken);
    },
  },
});

export const { createUser, setUserToken } = users.actions;
